import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { ManagePaths } from '../constants/routes';
export const getAiSettingsUrl = () => `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;
export const getBaseUrl = () => '/breeze-studio';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getSettingsUrl = () => `/settings/${PortalIdParser.get()}/account-defaults/general`;
export const redirectToMainSettings = () => {
  window.location.href = `${getFullUrl('app')}${getSettingsUrl()}`;
};
const getInboxSearch = ({
  agentInstanceId,
  executionId
}) => {
  const searchParams = new URLSearchParams();
  searchParams.set('agentInstanceId', String(agentInstanceId));
  if (executionId !== null && executionId !== void 0 && executionId.trim()) {
    searchParams.set('executionId', executionId);
  }
  const searchString = searchParams.toString();
  return searchString ? `?${searchString}` : '';
};
export const getInboxRoute = params => `${ManagePaths.INBOX}${getInboxSearch(params)}`;
export const getInboxUrl = params => `${getFullUrl('app')}${getRootUrl()}${getInboxRoute(params)}`;
export const getMarketplaceUrl = () => `${getFullUrl('app')}/marketplace/${PortalIdParser.get()}`;
export const getAgentMarketplaceUrl = referrer => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_PRODUCT_TYPE', 'AGENT');
  searchParams.set('eco_AGENT_TYPE', 'STUDIO');
  if (referrer) {
    searchParams.set('referrer', referrer);
  }
  return `${getMarketplaceUrl()}/explore?${searchParams.toString()}`;
};
export const getAssistantMarketplaceUrl = referrer => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_PRODUCT_TYPE', 'AGENT');
  searchParams.set('eco_AGENT_TYPE', 'ASSISTANT');
  if (referrer) {
    searchParams.set('referrer', referrer);
  }
  return `${getMarketplaceUrl()}/explore?${searchParams.toString()}`;
};
export const getMarketplaceListingUrl = (listingSlug, referrer = 'breeze') => {
  const searchParams = new URLSearchParams();
  searchParams.set('referrer', referrer);
  return `${getMarketplaceUrl()}/listing/${listingSlug}?${searchParams.toString()}`;
};
export const getConnectedAppsUrl = () => `${getFullUrl('app')}/connected-apps/${PortalIdParser.get()}/installed`;
export const getUserUrl = userId => `${getFullUrl('app')}/settings/${PortalIdParser.get()}/users/user/${userId}`;
const getWorkflowsBaseUrl = () => `${getFullUrl('app')}/workflows/${PortalIdParser.get()}`;
export const getCreateWorkflowUrl = ({
  agentInstanceId
}) => {
  const createUrl = `${getWorkflowsBaseUrl()}/create`;
  if (agentInstanceId) {
    const searchParams = new URLSearchParams();
    searchParams.set('agentInstanceId', String(agentInstanceId));
    return `${createUrl}?${searchParams.toString()}`;
  }
  return createUrl;
};
export const getEditWorkflowUrl = ({
  workflowId
}) => {
  return `${getWorkflowsBaseUrl()}/platform/flow/${workflowId}/edit`;
};
const getAutomationBaseUrl = () => `${getFullUrl('app')}/automation/${PortalIdParser.get()}`;
export const getAutomationFlowUrl = ({
  workflowId
}) => `${getAutomationBaseUrl()}/flow/${workflowId}`;